import * as React from "react";
import { required, TextInput } from "react-admin";
import Transformer from "../../common/Transformer";
import { CategoryEditComponent } from "./CategoryComponent";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const CategoryEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "articles"],
      update: {},
    });
    return data;
  };

  return (
    <Edit
      component={CategoryEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item lg={8}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item lg={8}>
            <TextInput source="slug" validate={required()} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
